export default __webpack_public_path__ + "static/media/elss (2).b829be77.png";